import { Link } from "react-router-dom";
import { LOGO_FULL, NAV_LINKS, COMPANY_LINKS, LEGAL_LINKS } from "@/lib/brand";

const COLS = [
  { title: "Plattform", links: NAV_LINKS },
  { title: "MatchGate", links: COMPANY_LINKS },
  { title: "Rechtliches", links: LEGAL_LINKS },
];

const testId = (label) =>
  `footer-link-${label
    .toLowerCase()
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")}`;

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/10 pt-16 pb-10"
    >
      <div className="px-6 md:px-10 lg:px-16">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-3 xl:col-span-5">
            <Link to="/" className="inline-block">
              <img
                src={LOGO_FULL}
                alt="MatchGate"
                className="h-9 w-auto object-contain mb-6"
              />
            </Link>
            <p className="max-w-sm text-base leading-relaxed text-white/50">
              Das Tor zwischen Sportvereinen und Sponsoren. Gebaut in
              Deutschland, für den Sport von morgen.
            </p>
          </div>

          {COLS.map((col) => (
            <div key={col.title} className="lg:col-span-3 xl:col-span-2">
              <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-white/40 mb-5">
                {col.title}
              </h4>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      data-testid={testId(l.label)}
                      className="text-sm text-white/60 hover:text-white transition-colors duration-300"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-white/10">
          <p className="text-xs text-white/40">
            © 2026 NxGn Media. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};
